import type { RootState } from "@/app/store";

export const selectJail = (state: RootState) => state.jail;
export const selectJailedUntil = (state: RootState) => state.jail.jailedUntil;
export const selectNextBustOutTime = (state: RootState) =>
  state.jail.nextBustOutTime;
export const selectIsBuyingOut = (state: RootState) => state.jail.isBuyingOut;
export const selectIsBustingOut = (state: RootState) => state.jail.isBustingOut;
